const navOverlay = () => {
    let tl;
    tl = gsap.timeline({paused: true});

    tl.addLabel('start');

    tl.to('.header__logo', {autoAlpha: 0, duration: 0.4}, 'start');
    tl.to('.header__hamburger', {autoAlpha: 0, duration: 0.4}, 'start');
    tl.to('.header__right--top', {autoAlpha: 0, duration: 0.4}, 'start');

    tl.to('.nav-overlay', {autoAlpha: 1, ease: Power1.easeOut, duration: 0.5, zIndex: 100}, '<0.25');


    tl.to('.nav-overlay__logo', {autoAlpha: 1, x: 0, y: 0, ease: Power1.easeOut, duration: 0.3}, '<0.25');
    tl.to('.nav-overlay #mobile-nav', {autoAlpha: 1, x: 0, y: 0, ease: Power1.easeOut, duration: 0.3}, '<0.25');
    tl.to('.nav-overlay #contact-nav', {autoAlpha: 1, x: 0, y: 0, ease: Power1.easeOut, duration: 0.3}, '<0.25');
    tl.to('.nav-overlay #overlay-social-nav', {autoAlpha: 1, x: 0, y: 0, ease: Power1.easeOut, duration: 0.3}, '<0.25');
    tl.to('.nav-overlay__close', {autoAlpha: 1, ease: Power1.easeOut, duration: 0.3}, '<0.1');
    tl.to('.line', {width: '100%', ease: Power1.easeOut, duration: 0.3}, '<0.25');

    document.addEventListener('click', function(e) {
        if (e.target.matches('.js__hamburger')) {
            e.preventDefault();
            document.body.classList.add('menu-open');
            tl.play();
        }
    });

    document.addEventListener('click', function(e) {
        let targetElement = e.target;
        while (targetElement !== null) {
            if (targetElement.matches('.nav-overlay__close')) {
                e.preventDefault();
                document.body.classList.remove('menu-open');
                tl.reverse();
                return; // exit the function
            }
            targetElement = targetElement.parentElement;
        }
    });

    const handleReverseOnLargeScreens = () => {
        if (window.innerWidth >= 1024) {
            tl.reverse();
            document.body.classList.remove('menu-open');
        }
    };

    // Initial call to handle the reverse if needed on page load
    handleReverseOnLargeScreens();

    // Event listener to handle the reverse when the window is resized
    window.addEventListener('resize', handleReverseOnLargeScreens);
};

navOverlay();